// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YZt_PJDi{background:var(--theme-background-near);border-radius:var(--radius);margin-inline:auto;padding:var(--space-large);width:min(1000px,100% - var(--space)*2)}`, "",{"version":3,"sources":["webpack://./src/page-components/shared/page-content/PageContent.module.scss"],"names":[],"mappings":"AAAA,UACE,uCAAA,CACA,2BAAA,CACA,kBAAA,CACA,0BAAA,CACA,uCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `YZt_PJDi`
};
export default ___CSS_LOADER_EXPORT___;
